import { Heading, VStack, Center, Text } from "native-base";
import React, { useState } from "react";
import { View as AnimatedView } from "react-native-animatable";
import { TouchableOpacity } from "react-native-gesture-handler";

import { isWeb } from "../../util/platform";
import { ArrowIcon } from "../icons/ArrowIcon";

interface IWelcomeWellbeing {
  onComplete: () => void;
}

export function WelcomeOnboardingFirst({ onComplete }: IWelcomeWellbeing) {
  const [animationState, setAnimationState] = useState<"In" | "OutDown">("In");
  return (
    <VStack space={8}>
      <AnimatedView
        style={{ width: "100%" }}
        animation={`fade${animationState}`}
        delay={100}
        duration={750}
      >
        <Heading fontWeight="600" textAlign="center">
          Miindset Wellbeing Checker
        </Heading>
      </AnimatedView>
      <VStack space={2}>
        <AnimatedView
          style={{ width: "100%" }}
          animation={`fade${animationState}`}
          delay={100 + 300 + 100}
          duration={750}
        >
          <Text
            textAlign="center"
            fontSize={!isWeb() ? 16 : 24}
            fontWeight="600"
          >
            Welcome!
          </Text>
        </AnimatedView>
        <AnimatedView
          style={{ width: "100%" }}
          animation={`fade${animationState}`}
          delay={100 + 300 + 100}
          duration={750}
        >
          <Text
            fontWeight={500}
            mb={2}
            fontSize={!isWeb() ? undefined : 20}
            textAlign="center"
          >
            To get the most out of the Miindset AI we need you to complete this
            quick wellbeing checker.
          </Text>
          <Text
            textAlign="center"
            lineHeight={20}
            fontWeight="bold"
            fontSize={!isWeb() ? 14 : 18}
          >
            It takes less than 30 seconds and will significantly improve your
            experience. All future wellbeing checks can be skipped and done
            whenever you feel your wellbeing has changed.
          </Text>
        </AnimatedView>
      </VStack>
      <AnimatedView
        style={{ width: "100%" }}
        animation={`fade${animationState === "In" ? "InUp" : "OutDown"}`}
        delay={100 + 300 + 400}
        onAnimationEnd={() => {
          if (animationState === "OutDown") {
            onComplete();
          }
        }}
        duration={1000}
      >
        <Center mt={6}>
          <TouchableOpacity
            activeOpacity={0.7}
            onPress={() => setAnimationState("OutDown")}
          >
            <ArrowIcon size="4xl" />
          </TouchableOpacity>
        </Center>
      </AnimatedView>
    </VStack>
  );
}
